export default "__VITE_ASSET__DNGNsWYR__"